import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReportDataMasseuse from "../utils/ReportDataMasseuse";

import DetailedReport from "../containers/DetailedReport";
import HighchartsConfig from '../../utils/HighchartsConfig';
import Highchart from "./Highchart";
import { withTheme } from '@material-ui/core';
import Constants from '../../utils/Constants';

class AlertsReport extends Component {
	constructor(props, context) {
		super(props, context);

		let {chartClasses, theme, filter} = props;

		this.state = {
			chartConfig: HighchartsConfig.merge({
				chart: {
					className: chartClasses.chart
				},
				title: {
					align: "left",
					text: "Alerts Received",
					style: {color: theme.palette.primary.darkGrey, fontSize: 14, fontWeight: 400}
				},
				accessibility: {
					point: {
						valueSuffix: " alerts"
					},
					description: `The number of alerts that were received per day over the last ${filter.previousDays} days.`
				},
				yAxis: {
					title: "",
					lineWidth: 0,
					gridLineWidth: 0,
					minRange : 0.1,
					allowDecimals: false,
					endOnTick: false,
					labels: {
						y: 0,
						style: {
							fontSize: 14,
							color: theme.palette.primary.darkGrey,
							fontWeight: 400
						}
					}
				},
				time: {
					useUTC: false
				},
				xAxis: {
					type: "datetime",
					tickWidth: 0,
					offset: 20,
					labels: {
						y: 35,
						rotation: -45,
						align: "center",
						style: {
							fontSize: 14,
							color: theme.palette.primary.darkGrey,
							whiteSpace: "nowrap",
							fontWeight: 400
						}
					}
				},
				plotOptions: {
					column: {
						//borderColor: theme.palette.primary.seaFoam
					}
				},
				series: [{
					type: "column",
					name: "Alerts",
					color: theme.palette.secondary.green
				}]
			}, {
				modifyTickInterval: true,
				previousDays: filter.previousDays
			})
		};

	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.data !== this.props.data) {
			let {chartConfig} = this.state,
				{data, suggestedClassname} = this.props;

			// TEMP
			//data = hardcodedData;

			if (data) {
				ReportDataMasseuse.convertDatesToMillis(data);
				chartConfig.series[0].className = suggestedClassname;
				chartConfig.series[0].data = ReportDataMasseuse.massageData(data, "period", "alerts");
				chartConfig.yAxis.labels.enabled = ReportDataMasseuse.getMaxValue(data, "alerts") !== 0;
			} else {
				chartConfig.series[0].data = null;
			}

			this.setState({chartConfig: chartConfig});
		}
	}

	render() {
		let {chartConfig} = this.state,
			{fidoError} = this.props;

		return (
			<DetailedReport
				fidoError={fidoError}
				ready={chartConfig.series[0].data && chartConfig.series[0].data.length > 0 ? true : false}>
				<Highchart
					darkTheme={false}
					pngExport
					chartConfig={chartConfig} />
			</DetailedReport>
		);
	}
}

AlertsReport.propTypes = {
	theme: PropTypes.object.isRequired,
	chartClasses: PropTypes.object.isRequired,
	showSnackbar: PropTypes.func,
	location: PropTypes.object,
	filter: PropTypes.object,
	data: PropTypes.array,
	fidoError: PropTypes.bool,
	suggestedClassname: PropTypes.string
};

export default withTheme(AlertsReport);
